<!-- Component that implements a list of documents -->
<template lang="html">
  <div>
    <v-dialog v-model="dialog" width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Confirma a exclusão do vínculo?
        </v-card-title>
        <v-card-text>
          <div v-if="this.vinculoParaExclusao.tipoVinculo !== 'superior'">
            Este vinculo foi feito pelo coordenador da ação {{this.vinculoParaExclusao.idProjeto}}.
            Se ele for excluído apenas o coordenador desta ação poderá refazê-lo.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="dialog = false">Não</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteVinculo()">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
    :headers="headers"
    :items="listaVinculos"
    :search="search"
    :no-data-text="'Esta ação não possui ações vinculadas.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.titulo="props">
        <router-link target="_blank" :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">
          {{ truncate(props.item.titulo, 100) }}
        </router-link>
      </template>
      <template v-slot:item.opcoes="props">
        <v-btn v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true"
        color="red darken-3" text icon @click="botaoExcluirVinculo(props.item)">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaVinculos.length }} projetos
      </template>
    </v-data-table>
    <br><br>
    <v-divider></v-divider>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      proxima="ParceriasProjeto"
      editar="EditarProjetoSuperior"
      nome_editar="Vincular"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao=true
    >
    </c-card-footer>
  </div>
</template>

<script>
import CardFooter from '@/components/c-card-footer'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'extensao'],
  data: () => ({
    dialog: false,
    vinculoParaExclusao: {},
    listaVinculos: [],
    projeto: {},
    projetoSuperior: {},
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Número', align: 'left', value: 'idProjeto' },
      { text: 'Título', align: 'left', value: 'titulo' },
      { text: 'Classificação Primária', align: 'left', value: 'classificacaoPrimaria.descricao' },
      { text: 'Classificação Secundária', align: 'left', value: 'classificacaoSecundaria.descricao' },
      { text: 'Situação', align: 'left', value: 'situacao.descricao' },
      { text: 'Coordenador', align: 'left', value: 'nomeCoordenador' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toVincular: function () {
      this.$router.push({ name: 'EditarProjetoSuperior', params: {idProjeto: this.projeto.idProjeto} })
    },
    toAvancar: function () {
      this.$router.push({ name: 'ParceriasProjeto', params: {idProjeto: this.projeto.idProjeto} })
    },
    botaoExcluirVinculo: function (item) {
      this.$set(this.vinculoParaExclusao, 'idProjeto', item.idProjeto)
      this.$set(this.vinculoParaExclusao, 'idProjetoSuperior', this.idProjeto)
      this.$set(this.vinculoParaExclusao, 'tipoVinculo', item.tipoVinculo)
      this.dialog = true
    },
    deleteVinculo: function () {
      this.dialog = false
      let idProjeto = this.vinculoParaExclusao.idProjeto
      let idProjetoSuperior = this.vinculoParaExclusao.idProjetoSuperior
      if (this.vinculoParaExclusao.tipoVinculo === 'superior') {
        idProjeto = this.vinculoParaExclusao.idProjetoSuperior
        idProjetoSuperior = this.vinculoParaExclusao.idProjeto
      }
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo vínculo.' })
      projetos.deleteProjetoSuperior(idProjeto, idProjetoSuperior)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregarVinculos()
      })
      .catch(error => {
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo vínculo.' })
      })
    },
    carregarProjeto: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.projeto.dataInicio = dates.format(this.projeto.dataInicio)
        this.projeto.dataConclusao = dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    carregarVinculos: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos vinculados.' })
      projetos.getVinculosDoProjeto(this.idProjeto)
      .then(response => {
        this.listaVinculos = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos vinculados.' })
      })
    }
  },
  mounted () {
    this.carregarProjeto()
    this.carregarVinculos()
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip,
    'c-card-footer': CardFooter
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-vinculos-tabela.vue?5a76a32e